import React from 'react';
import PropTypes from 'prop-types';
import { Select, Spin } from 'antd';

class RemoteSelectInput extends React.Component {
  static defaultProps = {
    idKey: 'id',
    nameKey: 'name',
    optionsKey: 'data',
    initialOptions: [],
    skipValues: [],
    notFoundContent: null,
    debounceTime: 300,
    minSymbolsForRequest: 3,
  };

  static propTypes = {
    idKey: PropTypes.string,
    nameKey: PropTypes.string,
    remoteLoader: PropTypes.func.isRequired, // the function expect "query" to search, and return object with {request, cancel: func}
    optionsKey: PropTypes.string.isRequired,
    initialOptions: PropTypes.array,
    skipValues: PropTypes.arrayOf(PropTypes.string),
    notFoundContent: PropTypes.string,
    defaultQuery: PropTypes.string,
    debounceTime: PropTypes.number,
    minSymbolsForRequest: PropTypes.number,
  }

  state = {
    loading: false,
    query: null,
    options: [],
    handler: null,
  }

  componentDidMount() {
    // on first render show options from prop (e.g. initial state) and then use autoselect
    this.state.options = this.props.initialOptions;
    if (this.props.defaultQuery) {
      this.onSearch(this.props.defaultQuery);
    }
  }

  onSearchSetQuery = (query) => {
    if (!this.props.debounceTime) {
      this.onSearch(query);
      return;
    }
    if (this.state.handler) {
      clearTimeout(this.state.handler);
    }

    const newHandler = setTimeout(() => {
      this.onSearch(query);
    }, this.props.debounceTime);

    this.setState({ handler: newHandler });
  }

  onSearch = async (query) => {
    if (query.length < this.props.minSymbolsForRequest) {
      return;
    }

    if (this.cancel) {
      this.cancel();
      this.cancel = null;
    }

    if (query === null) {
      return;
    }

    const loader = this.props.remoteLoader(query);
    this.cancel = loader.cancel;

    this.setState({ loading: true });

    loader.request.then((i) => {
      this.setState({ options: i[this.props.optionsKey] || [], loading: false });
    });
  }

  render() {
    const { idKey, nameKey, ...props } = this.props;

    return (
      <Select
        loading={this.state.loading}
        showSearch
        onSearch={this.onSearchSetQuery}
        notFoundContent={this.state.loading ? <Spin size="small" /> : this.props.notFoundContent}
        filterOption={false}
        {...props}
      >
        {this.state.options
          .filter(item => this.props.skipValues.indexOf(String(item[idKey])) === -1)
          .map(item => (
            <Select.Option key={item[idKey]} value={item[idKey]}>
              {item[nameKey]}
            </Select.Option>
          ))}
      </Select>
    );
  }
}

export default RemoteSelectInput;



// WEBPACK FOOTER //
// ./src/components/common/DataEntry/RemoteSelectInput/index.js